import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RUTA_IMATGES, rutaPagina } from '../Compartido/contenidoCamprodon.js';
import CabeceraSeccion from './CabeceraSeccion.jsx';

const APARTATS = [
    { pagina: "camprodon", imagen: "entorno-camprodon" },
    { pagina: "actividades", imagen: "entorno-actividades" },
];

// "Què fer a Camprodon?": foto a tot l'ample que canvia segons l'apartat
// que tens a sota del ratolí (o enfocat amb el teclat).
const Entorno = ({ textos, lang }) => {

    const { t } = useTranslation();

    const [actiu, setActiu] = useState(0);

    return (
        <section className="surroundings">
            <CabeceraSeccion {...textos.entorno} className="o-container" boton={{ href: rutaPagina("que-hacer", lang), label: t("Ver todo") }} />
            <div className="surroundings--container position-relative">
                <div className="surroundings--slide d-inline-flex">
                    {APARTATS.map((apartat, index) => (
                        <div
                            className="surroundings__item text-center color-white position-relative"
                            key={apartat.pagina}
                            onMouseEnter={() => setActiu(index)}
                            onFocus={() => setActiu(index)}
                        >
                            <div className="surroundings__content">
                                <div className="surroundings__item--title">{textos.entorno.items[index]}</div>
                                <a href={rutaPagina(apartat.pagina, lang)} className="surroundings__item--see-more text-uppercase color-white">{t("Ver más")}</a>
                            </div>
                        </div>
                    ))}
                    {APARTATS.map((apartat, index) => (
                        <picture key={"img" + apartat.pagina}>
                            <source srcSet={RUTA_IMATGES + apartat.imagen + ".webp"} type="image/webp" />
                            <img
                                src={RUTA_IMATGES + apartat.imagen + ".jpg"}
                                alt={textos.entorno.items[index]}
                                className="image-cover surroundings__img"
                                width="100%"
                                height="100%"
                                loading="lazy"
                                decoding="async"
                                data-active={index === actiu ? "true" : "false"}
                            />
                        </picture>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Entorno;
